import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { Store } from "src/app/shared/models/store";

@Component({
	selector: "app-venue-licenses",
	templateUrl: "./venue-licenses.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class VenueLicensesComponent implements OnInit {
	@Input() changesToSave: boolean;
	@Output() changesToSaveChange = new EventEmitter<boolean>();

	@Input() venue: Store;
	@Output() venueChange = new EventEmitter<Store>();

	constructor(public app: AppService, public venueService: OOVenueService) {}

	ngOnInit(): void {}
}
